<template>
  <div>
    <div class="info-block" v-if="!getUser.authorized_at">
      <svg v-if="!mobile" height="509.87489pt" viewBox="0 0 509.87489 509.87489" width="509.87489pt" xmlns="http://www.w3.org/2000/svg">
        <path d="m23.503906 198.367188 174.863282-174.863282c31.242187-31.242187 81.898437-31.242187 113.140624 0l174.863282 174.863282c31.242187 31.242187 31.242187 81.898437 0 113.140624l-174.863282 174.863282c-31.242187 31.242187-81.898437 31.242187-113.140624 0l-174.863282-174.863282c-31.242187-31.242187-31.242187-81.898437 0-113.140624zm0 0" fill="#dbbfa7"/>
        <g fill="#fff">
          <path d="m254.929688 142.9375c8.835937 0 16 7.164062 16 16v128c0 8.835938-7.164063 16-16 16-8.835938 0-16-7.164062-16-16v-128c0-8.835938 7.164062-16 16-16zm0 0"/>
          <path d="m238.929688 334.9375h32v32h-32zm0 0"/>
        </g>
      </svg>
      <div v-if="mobile">
        <div v-if="open">
          <div>
            <span v-if="!getUser.hours"> В настоящее время вы сможете забронировать место только за <strong>приветственные бонусы</strong>. У вас осталось <strong>{{ getUser.hours || 0 }}</strong> ч.</span>
            <br>Вам необходимо пройти процесс авторизации. Пожалуйста, обратитесь к администратору коворкинга.
          </div>
          <a href="javascript:void(0)" class="more-link" @click="open = false">скрыть</a>
        </div>
        <div v-else>
          <div>Вы сможете забронировать место только за <strong>приветственные бонусы</strong></div>
          <a href="javascript:void(0)" class="more-link" @click="open = true">подробнее</a>
        </div>
      </div>
      <div v-else>
        В настоящее время вы сможете забронировать место только за <strong>приветственные бонусы</strong>. У вас осталось <strong>{{ getUser.hours || 0 }}</strong> ч.
        <br>Вам необходимо пройти процесс авторизации. Пожалуйста, обратитесь к администратору коворкинга.
      </div>
    </div>
    <tabs class="tabs" :tabs="tabs" @changeTab="changeTabs"/>
    <wordk-calendar v-if="isRecords"/>
    <rent-work-state-calendar v-if="!isRecords"/>
  </div>
</template>

<script>
import Tabs from "@/components/functional/Tabs";
import WordkCalendar from "./CalendarApi/WorkingCalendar";
import RentWorkStateCalendar from "./CalendarApi/RentWorkStateCalendar";
import {mapGetters} from "vuex";

export default {
  name: "Calendar",
  components: {RentWorkStateCalendar, WordkCalendar, Tabs},
  data() {
    return {
      tabs: [],
      open: false,
      mobile: false,
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    isOpen() {
      if (!this.mobile) return true;
      return this.open;
    },
    isRecords() {
      return this.setTabs(this.$route.params.calendar === 'records')
    },
  },
  mounted() {
    this.mobile = window.innerWidth < 800;
  },
  methods: {
    setTabs(record) {
      this.tabs = [
        {
          name: 'Мои бронирования',
          isActive: !record,
          // tooltip: ' в этом разделе вы можете забронировать ' +
          //     'рабочее место. Выберите желаемое время, зону бронирования, ' +
          //     'место, оплатите онлайн или в коворкинге. Также вы ' +
          //     'можете купить пакет часов (дешевле) в разделе сайта ' +
          //     '"Наши услуги и цены" и оплата будет списана из вашего пакета.'
        },
        {
          name: 'Заказы клиентов',
          isActive: record,
          // tooltip: 'в этом разделе вы можете создать заказ ' +
          //     'клиента (данная функция позволит вам получать ' +
          //     'полную аналитику по вашим клиентам: доходы от ' +
          //     'записи, время посещения, частота посещений). ' +
          //     'Для того, чтобы создать заказ клиента вам сначала ' +
          //     'необходимо забронировать место в разделе ' +
          //     'Мои бронирования.'
        }
      ]
      return record
    },
    changeTabs(idx) {
      this.$router.push({
        name: 'master.cabinet.calendar',
        params: {calendar: idx ? 'records' : 'rents'}
      })
    },
  }
}
</script>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}

.info-block {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 20px;
  border: 1px solid #dbbfa7;
  border-radius: 5px;
  margin-bottom: 30px;
  background: white;

  & svg {
    height: 50px;
    width: 50px;
    margin-right: 20px;
  }
}

.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}

.tabs {
  margin-top: 0;
}

.filter {
  display: flex;
  border-bottom: 1px solid #E5E5E5;
  margin: 0 -30px;
  padding: 0 30px 30px 30px;

  & .item {
    margin: 0 10px;

    &:first-child {
      margin-left: 0;
    }
  }

}

.more-link {
  color: #b9765b;
}

button {
  background-color: unset;
  border: unset;
}

.calendar-control {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.calendar-title {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;

  & > span {
    font-weight: 500;
  }
}

.control-btn {
  color: #DBBFA7;
  margin-left: 19px;
  margin-right: 19px;
}

.today-btn {
  border: 1px solid #DBBFA7;
  border-radius: 5px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #DBBFA7;
  padding: 2px 15px;
}

@media (max-width: 800px) {
  .info-block {
    margin-bottom: 10px;
  }
}
</style>
